var STUDENT_NAME_MAX_VISIBLE_LENGTH = 10;
var ASSIGNMENT_NAME_MAX_VISIBLE_LENGTH = 10;
export { STUDENT_NAME_MAX_VISIBLE_LENGTH, ASSIGNMENT_NAME_MAX_VISIBLE_LENGTH };
